import {
  Skeleton,
  SkeletonProps,
  SkeletonTextProps,
  SkeletonCircle,
  SkeletonText,
  Stack
} from '@chakra-ui/react'

export default Skeleton
export { Skeleton, SkeletonCircle, SkeletonText, Stack }

export type { SkeletonProps, SkeletonTextProps }
